import * as yup from "yup";

export const buildStudentSchema = (
  t: (key: string, fallback: string) => string
) =>
  yup.object({
    studentCode: yup
      .string()
      .trim()
      .required(t("student-code-required", "Student code is required")),
    fullName: yup
      .string()
      .trim()
      .required(t("student-name-required", "Full name is required")),
    programId: yup.string().nullable(),
    gradeId: yup.string().nullable(),
    streamId: yup.string().nullable(),
    studentCategoryId: yup.string().nullable(),
    guardianPhone: yup.string().nullable(),
    guardianEmail: yup.string().email().nullable()
  });

export type StudentFormValues = yup.InferType<
  ReturnType<typeof buildStudentSchema>
>;
